//imports
import {
    UNIT_TYPE_EVENT_DELETE_OPEN_MODAL,
    UNIT_TYPE_EVENT_DELETE_REQUEST,
    UNIT_TYPE_EVENT_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    resultDeleteUnitTypeEvent: null,
    unitTypeEvents: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UNIT_TYPE_EVENT_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, unitTypeEvents: action.payload.unitTypeEvents }

        case UNIT_TYPE_EVENT_DELETE_REQUEST:
            return { ...state, loading: true }

        case UNIT_TYPE_EVENT_DELETE_RESULT:
            return { ...state, loading: false, resultDeleteUnitTypeEvent: action.payload }

        case CLEAR_REDUX:
            return ["", "UNIT_TYPE_EVENT_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};